module.exports = __webpack_public_path__ + "img/Story-Icon-Hero.379461e0.svg";